export const PlanNone = 'none'
export const PlanSmall = 'small'
export const PlanMedium = 'medium'
export const PlanLarge = 'large'

export const FrequencyMonthly = 'monthly'
export const FrequencyYearly = 'yearly'

export const FeatureFlagWorkout = 'workout'
